import * as React from "react";
import { useCallback, useState } from "react";
import useTimeout from "util/hooks/useTimeout";
import copyToClipboard from "util/copyToClipboard";
import Tooltip from "components/common/Tooltip";
const Copy = ({ children, value, timeout }) => {
  const [copied, setCopied] = useState(false);
  const { start } = useTimeout(() => setCopied(false), timeout);
  const copy = useCallback(
    () => copyToClipboard(value).then(() => {
      setCopied(true);
      start();
    }),
    [start, value]
  );
  return children({ copied, copy });
};
const ClipboardContainer = ({ children, text }) => /* @__PURE__ */ React.createElement(Copy, { value: text, timeout: 2e3 }, ({ copied, copy }) => copied ? /* @__PURE__ */ React.createElement(Tooltip, { label: "Copied!", withArrow: true, position: "top", opened: true }, children({ copy })) : children({ copy }));
export default ClipboardContainer;
